<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!--for overlay :loading="get_ay_std_ft_loader" -->
    <!--api- 1  -->
    <v-card class="box" v-if="appl_transaction_data != null">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Application Form Fees Report</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <!-- <v-row justify="center">
                    <v-col sm="5">
                        <h3>Application Form Fees Transaction Report</h3>
                    </v-col>
                </v-row> -->
        <v-row justify="center" dense class="mt-3">
          <v-col sm="2">
            <v-combobox rounded dense required v-model="current_academic_year"
              :items="appl_transaction_data.academic_year_list" item-text="Academic Year" label="Academic Year"
              outlined />
          </v-col>
          <v-col sm="2">
            <v-btn class="button mt-0" @click="getTransactionReport" :loading="fetch_btn_load">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- api-1 ends -->
    <br />
    <v-card class="box" v-if="records.length != 0">
      <v-toolbar flat dense class="toolbar" align="center" justify="center">
        <v-toolbar-title>Report</v-toolbar-title>
      </v-toolbar>
      <div id="my-table-id">
        <v-data-table id="print" :headers="header_list" :items="records" sort-by dense class="elevation-1 mytable"
          :search="search">
          <template v-slot:top>
            <v-toolbar flat dense color="white" align="center" justify="center">
              <!-- <v-toolbar-title>Report</v-toolbar-title>

                        <v-divider class="mx-4" inset vertical></v-divider> -->
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
                class="no-display"></v-text-field>

              <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
                <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
              </v-btn>

              <!-- <download-excel
              v-if="records.length != 0"
              color="primary"
              dark
              :data="records"
              :fields="xls_header"
              worksheet="My Worksheet"
              name="Transaction Report.xls"
              :title="xls_title"
            >
              <v-btn class="ma-2 no-display" tile outlined color="success">
                <v-icon left>mdi-file-excel</v-icon> Excel
                <v-icon right>mdi-download</v-icon>
              </v-btn>
            </download-excel> -->
              <v-btn rounded color="success" v-if="records.length != 0" outlined
                @click="fnExcelReport('my-table-id', 'ApplicationFormFeesTRansactionReport')" :loading="loader"><v-icon
                  color="success">mdi-export</v-icon>Export</v-btn>
            </v-toolbar>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    //1
    appl_transaction_data: null,
    // extraBreadcrumbItems: [
    

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    current_academic_year: null,
    fetch_btn_load: false,
    records: [],
    header_list: [],
    xls_header: [],
    xls_title: [],
    search: "",
  }),
  methods: {
       fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
    print() {
      // Get HTML to print from element
      const prtHtml = document.getElementById("print").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      console.log("stylesHtml>>" + stylesHtml);
      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
    
  </head>
   <body>
    ${prtHtml}
  </body>
</html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    getTransactionReport() {
      this.records = [];
      this.header_list = [];
      this.xls_header = [];
      this.xls_title = [];
      const data = {
        academic_year: this.current_academic_year,
      };
      axios
        .post("/Account/getAFFTReport", data)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "YES") {
              this.records = res.data.records;
              this.header_list = res.data.header_list;
              this.xls_header = res.data.xls_header;
              if (this.records.length == 0)
                this.showSnackbar("#b71c1c", "No Record found!!!");
            } else {
              console.log(res.data.status_reason);
            }
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    axios
      .post("/Account/applicationFFTReport")
      .then((res) => {
        if (res.data.msg == "200") {
          this.appl_transaction_data = res.data.appl_transaction_data;
          this.current_academic_year =
            res.data.appl_transaction_data.current_academic_year;
          this.load = true;
        } else {
        }
      })
      .catch((error) => {
        window.console.log(error);
      });
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
@media print {
  body {
    height: 100%;
    width: 100%;
  }
  .no-display {
    display: none !important;
  }
  .v-data-footer,
  .v-data-footer__select,
  .v-data-footer__pagination {
    display: none !important;
    visibility: hidden !important;
  }
  .v-data-table table,
  .v-data-table__wrapper {
    width: 100% !important;
    display: block !important;
  }

  table,
  th,
  td {
    border-collapse: collapse !important;
    border: 1px solid black !important;
    width: 100%;
    text-align: right !important;
  }
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
